<template lang="pug">
div
  .title {{ rateData.title }}
  .data-none(v-if="!rateData.list || rateData.list.length == 0") 暂无数据
  template(v-else)
    .list
      .l(style="color: #7825FA;") 男性占比
      .center(style="font-size: 14px;") 年龄段
      .r(style="color: #FA1B73;text-align: right;") 女性占比
    .list(
      v-for="(item, i) in rateData.list" :class="{ 'cur': curChooseData == item }" :key="item.name"
      @click="chooseItem(item, i)")
      .l
        .rate {{ item.rateFemale | rate }}
        .percent(v-if="item.rateFemale")
          span(:style="{ width: (item.rateFemale * 100).toFixed(2) + '%' }")
      .center {{ item.name }}
      .r
        .percent
          span(:style="{ width: (item.rateMale * 100).toFixed(2) + '%' }")
        .rate {{ item.rateMale | rate }}
</template>

<script>
export default {
  name: "SexRate",
  props: [ 'data', 'allSum', 'canClick' ],
  filters: {
    rate (v) {
      if (v) return v != '--' ? (v * 100).toFixed(2) + '%' : '--'
      return '0%'
    }
  },
  data () {
    return {
      noData: true,
      rateData: {
        title: '', list: []
      },
      curChooseData: null
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler (data) {
        this.handleRate(data || [])
      }
    }
  },
  methods: {
    handleRate (data) {
      let { title, list } = data
      if (list && list.length) {
        let sum = this.allSum || list.reduce((res, cur) => cur.num - 0 + res, 0)
        list.forEach(el => {
          el.rate = el.num && el.num > 0 && sum > 0 ? ((el.num / sum) * 100).toFixed(2) - 0 : 0
        })
      }
      this.noData = !list || list.length == 0
      this.rateData = { title, list }
      
      if (this.canClick) { // 可以点击自动选中第一个
        let list = this.rateData.list
        if (list && list.length) this.chooseItem(list[0])
      }
    },
    chooseItem (item) {
      if (!this.canClick) return
      this.curChooseData = item
      this.$emit('click', item, this.rateData)
    }
  }
}
</script>

<style lang="sass" scoped>
.list
  cursor: pointer
  border: 1px solid #fff
  border-left: 2px solid #fff
  border-right: 1px solid #fff
  &.cur
    border: 1px solid #7825FA
    border-left: 2px solid #7825FA
    border-right: 1px solid #fff
    padding-left: 20px
    margin-left: -20px
    padding-right: 51px
    margin-right: -51px
.title
  text-align: center
  font-weight: bold
  margin-bottom: 10px
.l, .r
  line-height: 40px
  display: inline-block
  width: calc(50% - 50px)
  .percent
    display: inline-block
    width: calc(100% - 60px)
    span
      display: inline-block
      height: 4px
      border-radius: 4px
  .rate
    display: inline-block
    width: 56px
.l
  padding-right: 5px
  .percent
    text-align: right
    margin-left: 4px
    span
      background: #7825FA
.r
  padding-left: 5px
  .percent
    text-align: left
    margin-right: 4px
    span
      background: #FA1B73
  .rate
    text-align: right
.center
  display: inline-block
  width: 100px
  text-align: center
  color: #878A92
  font-size: 12px
  border-radius: 4px
</style>